module.exports = __webpack_public_path__ + "img/logo.e856da18.png";